import React from 'react'
import Pane from 'components/Common/Pane'
import Heading from 'LuxKit/Typography/Heading'
import PriceModeSelectMobile from 'components/OfferPage/Filters/PriceModeSelect/PriceModeSelectMobile'
import Group from 'components/utils/Group'

export const ROOM_MODE_TOGGLE_SECTION_ID = 'roomModeToggleSection'

interface Props {
  charterBundleRoute?: App.CharterBundleRoute
}

function OfferPagePackagesHeading({
  charterBundleRoute,
}: Props) {
  return <Pane padding="20 20 16">
    <Group direction="horizontal" verticalAlign="center" horizontalAlign="space-between">
      <Heading variant="heading4">Select a package</Heading>
      {!!charterBundleRoute && <PriceModeSelectMobile />}
    </Group>
  </Pane>
}

export default OfferPagePackagesHeading
